import React, { useRef, useState } from 'react';
import { IconButton } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { usePageTourContext } from './PageTourProvider';
import HelpModal from './HelpModal';

const LandingHelpButton = () => {
  const { t } = useTranslation('onboarding');
  const { currentPage, hasSteps, startTour } = usePageTourContext();
  const [open, setOpen] = useState(false);
  const startAfterClose = useRef(false);

  if (!hasSteps || currentPage !== 'landing') return null;

  const handleExited = () => {
    if (!startAfterClose.current) return;
    startAfterClose.current = false;
    document.getElementById('root')?.removeAttribute('aria-hidden');
    window.setTimeout(() => startTour('landing'), 150);
  };

  return (
    <>
      <IconButton
        aria-label={t('helpEntry.ariaLabel')}
        onClick={() => setOpen(true)}
        sx={{
          position: 'fixed',
          top: { xs: 'auto', sm: 88 },
          bottom: { xs: 88, sm: 'auto' },
          right: { xs: 16, sm: 28 },
          width: 44,
          height: 44,
          zIndex: 1202,
          color: 'primary.contrastText',
          backgroundColor: 'primary.main',
          boxShadow: 4,
          '&:hover': { backgroundColor: 'primary.dark' },
        }}
      >
        <HelpOutline />
      </IconButton>
      <HelpModal
        open={open}
        onClose={() => setOpen(false)}
        onExited={handleExited}
        onStartTour={() => {
          startAfterClose.current = true;
          setOpen(false);
        }}
        currentPage="landing"
        hasPageTour={hasSteps}
      />
    </>
  );
};

export default LandingHelpButton;
